// ===== World 1: Breakfast chaos – THE KIT'S PARTS =====
// Principle: one new core part or machine at a time (plank, pad, banana, seesaw, paint, toaster, rope, pulley).
// Ball → goal: a pea → the porridge bowl. Coordinates: 1200 x 800. Levels: levels.ts
// Breakfast uses the kit's parts and drawing (the kitchen picture), so the world only has meta and levels.
import { defineWorld } from '../../core/registry';
import type { WorldMeta } from '../../core/types';
import { levels } from './levels';
import { strings } from './strings';

// ---------- meta ----------
const meta: WorldMeta = {
  icon: '🥣', strings, music: 'breakfast.mp3',
  credits: { title: 'Sunshine in the Kitchen', artist: 'kissan4', id: 346133, url: 'https://pixabay.com/music/acoustic-group-sunshine-in-the-kitchen-346133/' },
  synth: { bpm: 80, root: 293.7, sc: 'major', prog: [0, 3, 4, 0], bar: 4, lead: 'pluck', dens: 0.5 },
};

const world = defineWorld({
  k: 'breakfast',
  meta,
  levels,
});
export default world;
